export default __webpack_public_path__ + "static/media/img_publi6.7de46c9b.svg";